// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
const { withRouter } = require('react-router-dom');

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const {
    MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL
} = require('constants/index');

// @components
const PensionPlanPeriodicCancelDataTable = require('components/broker/brokerPensionPlanContribution/pensionPlanPeriodic/pensionPlanPeriodicCancelDataTable/pensionPlanPeriodicCancelDataTable');

class BrokerPensionPlanPeriodicCancelSuccess extends React.Component {

    constructor(props) {
        super(props);
        this.handleSecondaryClick = this.handleSecondaryClick.bind(this);
    }

    handleSecondaryClick() {
        const { history, plan } = this.props;
        history.replace('/myprofile/broker/ordersAndMovements/' + plan.getIn(['contrato','numerodecontrato']));
    }

    render(){
        const { plan, immBrokerPensionPlanPeriodicalContribution } = this.props;
        const infoPlan = (
            <PensionPlanPeriodicCancelDataTable
                plan={plan}
                cancelled={true}
                immBrokerPensionPlanPeriodicalContribution={immBrokerPensionPlanPeriodicalContribution}
            />
        );
        const successMessage = formatText('pensionPlanContribution-cancelSuccessMessage');
        const mainButtonLabel = formatText('pensionPlanContribution-successMainButtonEdit');
        const secondaryButtonLabel = formatText('pensionPlanContribution-successSecondaryButton');
        const cancelPeriodicPlanUrl = MYPROFILE_BROKER_PENSION_PLAN_PERIODICAL_CONTRIBUTION_URL;

        return (

            <WizardSuccess
                successMessage={successMessage}
                customClassName="etfs-buy-success"
                mainButton={{label: mainButtonLabel, url: cancelPeriodicPlanUrl, modifier: 'secondary'}}
                secondaryButton={{label: secondaryButtonLabel}}
                onSecondaryButtonClick={this.handleSecondaryClick}
            >
                {infoPlan}
            </WizardSuccess>
        );
    }
}

BrokerPensionPlanPeriodicCancelSuccess.propTypes = {
    history: PropTypes.object.isRequired,
    plan: PropTypes.object.isRequired,
    immBrokerPensionPlanPeriodicalContribution: PropTypes.object.isRequired
};

module.exports = withRouter(BrokerPensionPlanPeriodicCancelSuccess);
